import GlobeMap3D from '@/components/three/GlobeMap3D';

// Mappa del sito: sempre globo 3D (stessa API della vecchia mappa 2D).
export default function MapView({
  center = [42.5, 12.5],
  zoom = 5,
  listings = [],
  height = '520px',
  onPick,
  pickedPoint,
  myLocation,
}) {
  return (
    <GlobeMap3D
      listings={listings}
      height={height}
      focus={center}
      zoom={Math.max(7, zoom)}
      onPick={onPick}
      pickedPoint={pickedPoint}
      myLocation={myLocation}
      showHud={listings.length > 1}
    />
  );
}
